import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../common/widgets/Dialog';
import Input from '../../../../../../../common/widgets/Input';
import Multiselect from '../../../../../../../common/widgets/Multiselect';
import {
  CityFilterModel,
  CountyFilterModel,
} from '../../../../../models/filters';
import { resources } from '../../../../../resources/resources';

interface EditLocationDialogProps {
  selectedEditCounty: CountyFilterModel;
  countyCities: CityFilterModel[];
  closeDialog: () => void;
  editLocation: (selectedEditCounty: CountyFilterModel) => void;
}

export const EditLocationDialog = (props: EditLocationDialogProps) => {
  const { selectedEditCounty, countyCities, closeDialog, editLocation } = props;
  const [selectedCities, setSelectedCities] = useState<
    CityFilterModel[] | undefined
  >(selectedEditCounty?.cities ?? undefined);
  const { t: translate } = useTranslation();
  const allCitiesFilterId = -1;

  const cities = countyCities?.length
    ? [
        {
          name:
            countyCities.length === 1
              ? translate(
                  resources.products.add.productDetails.location.addLocations
                    .dialog.allCities.single,
                )
              : translate(
                  resources.products.add.productDetails.location.addLocations
                    .dialog.allCities.multiple,
                  { 0: countyCities.length },
                ),
          filterId: allCitiesFilterId,
        },
        ...countyCities,
      ]
    : [];

  const onSaveClick = () => {
    editLocation({
      filterId: selectedEditCounty!.filterId,
      name: selectedEditCounty!.name,
      cities: selectedCities!,
    });
  };

  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      className="dialog-merchants-edit"
    >
      <div className="dialog-content">
        <div className="dialog-title">
          {translate(
            resources.products.add.productDetails.location.addLocations.dialog
              .edit.title,
          )}
        </div>
        <div className="dialog-text centered mb-20">
          {translate(
            resources.products.add.productDetails.location.addLocations.info,
          )}
        </div>
        <Input
          value={
            selectedEditCounty.name ?? { name: translate(resources.select) }
          }
          label={translate(
            resources.products.add.productDetails.location.addLocations.dialog
              .edit.countyLabel,
          )}
          disabled
        />
        <Multiselect
          controlClassName="mb-0"
          data={cities}
          value={selectedCities}
          placeholder={translate(resources.select)}
          onChange={e => {
            if (
              e.value.some(
                (f: CityFilterModel) => f.filterId === allCitiesFilterId,
              )
            ) {
              setSelectedCities(countyCities ?? []);
            } else {
              setSelectedCities(e.value);
            }
          }}
          textField="name"
          dataItemKey="filterId"
          label={translate(
            resources.products.add.productDetails.location.addLocations.dialog
              .city,
          )}
        />
      </div>

      <div className="dialog-actions vertical">
        <Button
          className="btn btn-solid"
          onClick={onSaveClick}
          disabled={!selectedCities?.length}
        >
          <span className="btn-text">{translate(resources.saveChanges)}</span>
        </Button>
      </div>
    </Dialog>
  );
};
